export default "__VITE_ASSET__fd2d482f__"